import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateBarComponent } from './update-bar.component';
import { SharedModule } from '../../shared.module';
import { UiModule } from '../../ui/ui.module';


@NgModule({
	declarations: [
		UpdateBarComponent
	],
  imports: [
    CommonModule,
    SharedModule,
    UiModule
  ],
	exports: [
		UpdateBarComponent
	]
})
export class UpdateBarModule {
}
